module.exports = __webpack_public_path__ + "static/img/prod-rx.2b039cbf.jpg";